import getMarketSupportByZipCodeConfiguration from '@root/joinroot.com/src/api/get-market-support-by-zip-code-configuration';
import useSafeNetworkRequest from '@root/core/src/hooks/use-safe-network-request';
import { useMemo } from '@root/vendor/react';

export default function useGetMarketSupportByZipCode(zipCode, callback) {
  const configuration = useMemo(() => getMarketSupportByZipCodeConfiguration(zipCode), [zipCode]);
  return useSafeNetworkRequest(configuration, callback);
}
